import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { shopApi } from '../../utils/shopApi';
import { ShoppingBag, Clock, Truck, Banknote } from 'lucide-react';

const formatRWF = (n) => new Intl.NumberFormat('en-RW', { maximumFractionDigits: 0 }).format(n || 0);

export default function ShopAdminDashboard() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    shopApi.get('/shop/admin/dashboard').then(r => setStats(r.data)).catch(() => {});
    shopApi.get('/shop/admin/orders').then(r => setRecent(r.data.slice(0, 10))).catch(() => {});
  }, []);

  const cards = [
    { label: 'Total orders', value: stats?.total_orders, icon: ShoppingBag, color: 'bg-blue-50 text-blue-700' },
    { label: 'Pending', value: stats?.pending, icon: Clock, color: 'bg-amber-50 text-amber-700' },
    { label: 'Out for delivery', value: stats?.out_for_delivery, icon: Truck, color: 'bg-purple-50 text-purple-700' },
    { label: 'Revenue', value: `RWF ${formatRWF(stats?.total_revenue)}`, icon: Banknote, color: 'bg-green-50 text-green-700' },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-serif font-bold">Dashboard</h1>
        <p className="text-sm text-muted-foreground">Bison Shop overview</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="shop-admin-dashboard-stats">
        {cards.map(c => (
          <div key={c.label} className="p-4 bg-white rounded-xl border border-border">
            <div className={`w-9 h-9 rounded-lg ${c.color} flex items-center justify-center mb-2`}><c.icon className="w-4 h-4" /></div>
            <div className="text-xs text-muted-foreground">{c.label}</div>
            <div className="text-2xl font-bold mt-0.5">{c.value ?? '–'}</div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-xl border border-border overflow-hidden">
        <div className="p-4 border-b border-border flex items-center justify-between">
          <div className="font-semibold">Recent orders</div>
          <Link to="/shop-admin/orders" className="text-sm text-primary hover:underline">View all →</Link>
        </div>
        {recent.length === 0 ? (
          <div className="p-10 text-center text-muted-foreground text-sm">No orders yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-muted/30"><tr><th className="text-left p-3">Order</th><th className="text-left p-3">Customer</th><th className="text-right p-3">Total</th><th className="text-left p-3">Status</th></tr></thead>
            <tbody>
              {recent.map(o => (
                <tr key={o.id} className="border-t border-border">
                  <td className="p-3 font-mono">#{o.order_number}</td>
                  <td className="p-3">{o.customer_name}</td>
                  <td className="p-3 text-right">RWF {formatRWF(o.total)}</td>
                  <td className="p-3 capitalize"><span className="px-2 py-0.5 rounded-full text-xs bg-primary/10 text-primary">{o.status.replace(/_/g, ' ')}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
